import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _get from 'lodash/get';

import Col from 'ravenjs/lib/Col';
import Row from 'ravenjs/lib/Row';
import TextArea from 'ravenjs/lib/TextArea';
import Typography from 'ravenjs/lib/Typography';

import { callFunc, getHandler } from 'ravenjs/utils/actions';
import FormGroupTitle from './FormGroupTitle';

class LegislationNotesField extends Component {
    constructor(props) {
        super(props);

        const { formData } = this.props;

        this.state = {
            errors: false,
            formData,
            typingTimeout: null,
        };
    }

    handleOnChange = evt => {
        const notes = evt.target.value;
        const { typingTimeout } = this.state;

        if (typingTimeout !== null) {
            clearTimeout(typingTimeout);
        }

        const timeout = setTimeout(() => {
            this.setState(
                () => ({ formData: notes }),
                () => {
                    this.saveNotes(notes);
                }
            );
        }, 1000);

        this.setState({
            typingTimeout: timeout,
        });
    };

    handleOnBlur = evt => {
        const notes = this.state.formData;
        this.saveNotes(notes);
    };

    saveNotes = _notes => {
        const { formContext } = this.props;
        const { handlers = {} } = formContext;
        const updateNotes = getHandler(handlers, 'updateNotes');

        if (_notes.length <= 2000) {
            callFunc(updateNotes, {
                notes: _notes,
            });
            this.setState({
                errors: false,
            });
        } else {
            this.setState({
                errors: true,
            });
        }
    };

    render() {
        const { errors, formData } = this.state;
        const { idSchema, required, schema } = this.props;
        const id = _get(idSchema, '$id', '');
        const title = _get(schema, 'title');
        const titleHelptext = _get(schema, 'helpText');
        const notesStyles = {
            overflowY: 'scroll',
        };
        const message = errors ? (
            <Typography color="error" gutterBottom="0" style={{ margin: '10px 5px' }}>
                You have exceed 2000 characters limit.
            </Typography>
        ) : (
            ''
        );

        return (
            <Row width="auto">
                <Col size={12}>
                    <FormGroupTitle
                        helpText={titleHelptext}
                        id={id}
                        required={required && Boolean(!formData)}
                        title={title}
                    />
                </Col>
                <Col size={12} style={{ position: 'relative' }}>
                    <TextArea
                        defaultValue={formData}
                        onChange={this.handleOnChange}
                        onBlur={this.handleOnBlur}
                        placeholder="Type your note here"
                        rows={5}
                        style={notesStyles}
                    />
                    {message}
                </Col>
            </Row>
        );
    }
}

LegislationNotesField.propTypes = {
    formContext: PropTypes.object,
    formData: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    idSchema: PropTypes.object,
    required: PropTypes.bool,
    schema: PropTypes.object,
};

LegislationNotesField.defaultProps = {
    formContext: null,
    formData: null,
    idSchema: null,
    required: null,
    schema: null,
};

export default LegislationNotesField;
